"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateUserRequest = exports.GetUserResponse = exports.CreateUserResponse = exports.CreateUserRequest = exports.SubscriptionStatus = exports.UserRoles = void 0;
const zod_1 = require("zod");
const userPermission_types_1 = require("./userPermission.types");
var UserRoles;
(function (UserRoles) {
    UserRoles["ADMIN"] = "ADMIN";
    UserRoles["USER_OWNER"] = "USER_OWNER";
    UserRoles["USER_ADMIN"] = "USER_ADMIN";
    UserRoles["USER_MANAGER"] = "USER_MANAGER";
    UserRoles["USER_EMPLOYEE"] = "USER_EMPLOYEE";
})(UserRoles || (exports.UserRoles = UserRoles = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["TRIAL"] = "TRIAL";
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["EXPIRED"] = "EXPIRED";
    SubscriptionStatus["UNKNOWN"] = "UNKNOWN";
})(SubscriptionStatus || (exports.SubscriptionStatus = SubscriptionStatus = {}));
const UserDetailsSchema = zod_1.z.object({
    id: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    phoneNumber: zod_1.z.string(),
    email: zod_1.z.string(),
    enabled: zod_1.z.boolean(),
    role: zod_1.z.string(),
    companyId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    subscription: zod_1.z.object({
        isActive: zod_1.z.boolean(),
        status: zod_1.z.nativeEnum(SubscriptionStatus),
        startDate: zod_1.z.string().datetime().optional(),
        endDate: zod_1.z.string().datetime().optional(),
    }),
    permission: userPermission_types_1.UserPermissionSchema,
    twoFactorEnabled: zod_1.z.boolean(),
});
exports.CreateUserRequest = zod_1.z.object({
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    dateOfBirth: zod_1.z.string().date().optional(),
    phonePrefix: zod_1.z.string().optional(),
    phoneNumber: zod_1.z.string(),
});
exports.CreateUserResponse = UserDetailsSchema;
exports.GetUserResponse = UserDetailsSchema;
exports.UpdateUserRequest = zod_1.z.object({
    firstName: zod_1.z.string().min(1),
    lastName: zod_1.z.string().min(1),
    phoneNumber: zod_1.z.string().min(1),
    email: zod_1.z.string().email().optional(),
    twoFactorEnabled: zod_1.z.boolean().optional(),
});
